namespace TabAurous.Finance {
    export interface JournalDetailForm {
        TransDetailsId: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        Mode: PaymentModesEditor;
        Amount: Serenity.DecimalEditor;
        ExchangeRateId: Serenity.DecimalEditor;
        ChequeNo: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
    }

    export class JournalDetailForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.JournalDetail';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JournalDetailForm.init)  {
                JournalDetailForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = PaymentModesEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateEditor;

                Q.initFormType(JournalDetailForm, [
                    'TransDetailsId', w0,
                    'LedgerId', w1,
                    'Mode', w2,
                    'Amount', w3,
                    'ExchangeRateId', w3,
                    'ChequeNo', w0,
                    'ChequeDate', w4
                ]);
            }
        }
    }
}
